export default "__VITE_ASSET__CQi8wiMV__"